import Warning from '@mui/icons-material/Warning';
import { Box } from '@mui/system';
import { AlertTooltip } from '@openx/components-core/lib/AlertTooltip/AlertTooltip.tsx';
import { DateLabel } from '@openx/components-core/lib/DateLabel/DateLabel.tsx';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder.tsx';
import { isPast } from 'date-fns';
import { useTranslation } from 'react-i18next';

type ExpirationDateCellProps = {
  expirationDate?: string | null;
  children?: React.ReactNode;
};

export const ExpirationDateCell = ({ expirationDate, children }: ExpirationDateCellProps) => {
  const { t } = useTranslation();
  const date = expirationDate ? new Date(expirationDate) : null;
  const showExpiredAlert = date ? isPast(date) : false;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {expirationDate ? (
        children ? (
          children
        ) : (
          <DateLabel date={expirationDate} displayExactDate dateFormat="yyyy-MM-dd" showOffset={false} />
        )
      ) : (
        <ValuePlaceholder />
      )}

      {showExpiredAlert && (
        <AlertTooltip
          color={theme => theme.palette.warning.main}
          sx={{ ml: 2 }}
          title={t('This API key is expired')}
          icon={<Warning data-test="expired-icon" fontSize="small" color="inherit" />}
        />
      )}
    </Box>
  );
};
